export interface ActivityPreview {
  id: string
  image: string
  caption: string
  volume: string
}

export const activityPreviews: ActivityPreview[] = [
  {
    id: 'block-stack-addition',
    image:
      'https://cdn.magicpatterns.com/uploads/obW83ARAzerpKEJaUBCtKE/06_foundations_block_stack_addition.png',
    caption: 'Block Stack Addition',
    volume: 'Volume 1 · Foundations',
  },
  {
    id: 'tens-and-ones-towers',
    image:
      'https://cdn.magicpatterns.com/uploads/m7yQjMJ44E2sRyQKH4fCut/07_foundations_place_value_builder.png',
    caption: 'Tens and Ones Towers',
    volume: 'Volume 1 · Foundations',
  },
  {
    id: 'times-table-mine',
    image:
      'https://cdn.magicpatterns.com/uploads/344u9scPd7TpWb4zZ2oPnk/08_builders_times_table_mine.png',
    caption: 'Times Table Mine',
    volume: 'Volume 2 · Builders',
  },
  {
    id: 'division-caves',
    image:
      'https://cdn.magicpatterns.com/uploads/fiYiqwVBAShdJKPcutZNau/09_builders_division_caves.png',
    caption: 'Division Caves',
    volume: 'Volume 2 · Builders',
  },
  {
    id: 'one-step-quests',
    image:
      'https://cdn.magicpatterns.com/uploads/7rCDTPfSZ8e69fAGdzsDdm/10_masters_word_problem_adventures.png',
    caption: 'One-Step Quests',
    volume: 'Volume 3 · Masters',
  },
  {
    id: 'ruler-reading',
    image:
      'https://cdn.magicpatterns.com/uploads/uS5Eqp71cxaGQFhb1yWeTv/11_masters_measurement_time.png',
    caption: 'Ruler Reading',
    volume: 'Volume 3 · Masters',
  },
]
